import React, { Component } from 'react';
import UserContainer from '../../../containers/UserContainer';
import cookie from 'react-cookies';

interface IState {
  userInfo: string;
  userLoaded: boolean;
}

class UserInfoPage extends Component<any, IState> {
  constructor(props: any) {
    super(props);
    this.state = {
      userInfo: '',
      userLoaded: false
    };
  }

  render() {
    return (
      <div className="header-user-info text-white align-middle header-name-holder">
        {!this.state.userLoaded && (
          <UserContainer>
            {({ data }) => {
              console.log(`userInfo`, data);
              if (data && data.UserInfo != null) {
                let name = `${data.UserInfo.firstName} ${data.UserInfo.lastName}`;
                localStorage.setItem('user_info', name);

                if (data.UserInfo.roles !== '') {
                  localStorage.setItem('roles', `${data.UserInfo.roles}`);
                }
                if (data.UserInfo.superUser !== '') {
                  localStorage.setItem('strn', `${data.UserInfo.superUser}`);
                } else {
                  localStorage.removeItem('strn');
                }

                return (
                  <span>
                    {data.UserInfo.firstName} {data.UserInfo.lastName}
                  </span>
                );
              }
              return null;
            }}
          </UserContainer>
        )}
        {this.state.userLoaded && <span>{this.state.userInfo}</span>}
      </div>
    );
  }
}

export default UserInfoPage;
